import React from 'react';
import { Modal, Button } from 'lmc-ui-library';
import { Nullable } from 'utils/types';
import { BadRequestError } from 'screens/Panel/api/errorHandler';

const ErrorModal: React.FC<{ show: boolean; error: Nullable<Error>; onClose?: () => void }> = ({
  show,
  error,
  onClose,
}) => {
  let errorMessage: string = '';
  if (error !== null) {
    errorMessage = 'Unexpected error occured';
  }
  if (error instanceof BadRequestError && error.getMessage()) {
    errorMessage = error.getMessage();
  }

  return (
    <Modal isOpen={show} showCloseBtn={false} onClose={onClose}>
      <Modal.Header title={'Error!'} mode="error" />
      <Modal.Content>{errorMessage}</Modal.Content>
      <Modal.Footer>
        <Button borderVariant="rectangle" mode="ghost" width="100%" onClick={onClose}>
          <b>Close</b>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorModal;
